import React from 'react'

export const CtiVideoCompound = ({ id, contentType, classNames }) => {
  return (
    <div className={`CtiVideoCompound ${classNames || ''}`} key={id}>
      <div>{contentType} needs implementation</div>
    </div>
  )
}
